import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Carousel } from 'primereact/carousel';
import { handleGetRequest } from '../../services/GetTemplate';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';

function EditProducts() {
    const [productData, setProductData] = useState()
    const [selectedImage, setSelectedImage] = useState(productData?.images[0]?.src);
    const [loading , setLoading]= useState(false)
    

    const { id } = useParams()
    const navigate= useNavigate()

    const getProduct = async () => {
        setLoading(true)
        const response = await handleGetRequest(`/ShopifyData/GetProductById?productId=${id}`, true);
        setProductData(response[0])
        setLoading(false)
    }
    useEffect(() => {
        getProduct()
    }, [id])

    const tags = ['tag1', 'tag2']
    return (
        <div className="card Card__Round">  
            <h4>Product Details</h4>
            {loading ? (
                <div className="flex justify-content-center align-items-center" style={{ height: '300px' }}>
                    <ProgressSpinner />
                </div>
            ) : (
                <div className="p-fluid p-formgrid grid">
                    {/* Left Section */}
                    <div className="col-12 md:col-6">
                        <Card style={{ padding: '0', borderRadius: '12px', marginBottom: '1rem' }}>
                            <img
                                src={productData?.images[0]?.src}
                                alt="Product"
                                style={{
                                    width: '100%',
                                    height: '430px',
                                    borderRadius: '8px',
                                    objectFit: 'cover'
                                }}
                            />
                        </Card>

                        {/* Image Slider */}
                        {/* <Carousel value={product.images} numVisible={3} numScroll={1} itemTemplate={renderCarouselItem} circular autoplayInterval={5000} className="p-mt-2" /> */}
                    </div>

                    {/* Right Section */}
                    <div className="col-12 md:col-6">
                        <Card style={{ padding: '2rem', borderRadius: '12px' }}>
                            <h2 className="p-text-bold">{productData?.product?.title}</h2>
                            <h4 className="p-mb-0 p-text-success">SKU:{productData?.variants[0]?.sku}</h4>
                            <h3 className="p-mb-4 p-mt-0 p-text-success">Price:${productData?.variants[0]?.price}</h3>

                            {/* Status */}
                            <div className="p-mb-3">
                                <span className="p-text-bold p-mr-2">Status:&nbsp;</span>
                                <Tag value={productData?.variants[0]?.inventoryQuantity > 0 ? 'In Stock' : 'Out of stock'} severity={productData?.variants[0]?.inventoryQuantity > 5 ? 'success' : 'danger'} />
                            </div>

                            {/* Description */}
                            <div className="p-mb-3">
                                <h4 className="p-text-bold mt-3 mb-0">Description</h4>
                                <p>{productData?.product?.body_html === null ? 'No description has been added yet' : productData?.product?.body_html}</p>
                            </div>

                            {/* Specifications */}
                            <div className="p-mb-3">
                                <h4 className="p-text-bold mt-3 mb-0">Specifications</h4>
                                {/* <ul className="p-pl-3">{productData?.product?.body_html === null ? 'No description have been added yet' : productData?.product?.body_html}</ul> */}
                                <p>{productData?.product?.body_html === null ? 'No specification has been added yet' : productData?.product?.body_html}</p>
                            </div>

                            {/* Tags */}
                            <div className="p-mb-3 mt-4">
                                <h4 className="p-text-bold">Tags</h4>
                                <div>
                                    {productData?.product?.tags?.split(',').map((tag, index) => (
                                        <Tag key={index} value={tag} style={{ marginRight: '0.5rem', marginBottom: '0.5rem' }} />
                                    ))}
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            )}
            <div className="flex justify-content-center">
                <Button type="submit" label="Ok" className="Btn__Dark" onClick={() => navigate('/products')} />
            </div>
        </div>
    );
}

export default EditProducts;
